import { Button, Form, Input, Modal, Select, message } from "antd";
import React, { useEffect, useMemo } from "react";
import { useLoading } from "../../context/loadingContext";
import {
  createProductType,
  updateProductType,
} from "../../functions/reference/productTypeAdmin";
import { bg_button } from "constant/css";

const PAYMENT_TYPE_OPTIONS = [
  { value: "PAYMENT", label: "PAYMENT — төлбөр (payment данс)" },
  { value: "PURCHASE", label: "PURCHASE — худалдан авалт" },
  { value: "PAYMENT_TDB", label: "PAYMENT_TDB" },
  { value: "PAYMENT_POS", label: "PAYMENT_POS" },
  { value: "PURCHASE_POS", label: "PURCHASE_POS" },
];

const SETTLE_TYPE_OPTIONS = [
  { value: "INSTANT", label: "INSTANT — шууд гүйлгээ" },
  {
    value: "BATCH",
    label: "BATCH — өндөрлөгөөний багц (INSTANT биш)",
  },
];

const ProductTypeEditModal = ({ open, close, record, refresh }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const isEdit = Boolean(record?.id);

  const settleOptions = useMemo(() => {
    const base = [...SETTLE_TYPE_OPTIONS];
    const current = record?.settleType;
    if (current && !base.some((o) => o.value === current)) {
      base.push({ value: current, label: `${current} (одоогийн)` });
    }
    return base;
  }, [record?.settleType]);

  useEffect(() => {
    if (!open) return;
    if (record) {
      form.setFieldsValue({
        name: record.name,
        paymentType: record.paymentType,
        settleType: record.settleType || "INSTANT",
      });
    } else {
      form.setFieldsValue({
        paymentType: "PAYMENT",
        settleType: "INSTANT",
      });
    }
  }, [open, record, form]);

  const onFinish = async (values) => {
    showLoading();
    try {
      const response = isEdit
        ? await updateProductType(record.id, values)
        : await createProductType(values);
      hideLoading();
      if (!response?.success) {
        message.error(
          response?.message || "Хадгалахад алдаа гарлаа"
        );
        return;
      }
      message.success(isEdit ? "Шинэчлэгдлээ" : "Нэмэгдлээ");
      close();
      refresh?.();
    } catch (e) {
      hideLoading();
      message.error(e?.message || "Алдаа гарлаа");
    }
  };

  return (
    <Modal
      title={isEdit ? "Бүтээгдэхүүний төрөл засах" : "Бүтээгдэхүүний төрөл нэмэх"}
      open={open}
      onCancel={close}
      footer={null}
      destroyOnClose
      width={520}
    >
      <Form form={form} layout="vertical" onFinish={onFinish} className="mt-2">
        <Form.Item
          label="Нэр"
          name="name"
          rules={[{ required: true, message: "Нэр оруулна уу" }]}
        >
          <Input placeholder="Жишээ: Цахилгаан" />
        </Form.Item>
        <Form.Item
          label="Гүйлгээний төрөл (paymentType)"
          name="paymentType"
          rules={[{ required: true, message: "Сонгоно уу" }]}
          extra="QPay данс, processing шимтгэл API/constant.js-ээс"
        >
          <Select options={PAYMENT_TYPE_OPTIONS} />
        </Form.Item>
        <Form.Item
          label="Өндөрлөгөө (settleType)"
          name="settleType"
          rules={[{ required: true, message: "Сонгоно уу" }]}
        >
          <Select options={settleOptions} />
        </Form.Item>
        <div className="flex justify-end gap-2">
          <Button onClick={close}>Болих</Button>
          <Button type="primary" htmlType="submit" className={bg_button}>
            {isEdit ? "Хадгалах" : "Нэмэх"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ProductTypeEditModal;
